// 404Page.js
import React from 'react';
import { Link } from 'react-router-dom';
import ActionButton from '../../component/ActionButton';
import { Product } from '../../util/Utils';
import { THEME } from '../../util/LookupConst';
import LogoGaBig from "../../assets/images/ga/logo-ga-big.png";
import SipLongLogo from "../../image/sip_long_logo.png";
import CricoLogo from "../../assets/images/crico/crico_expanded_view_logo.png";

const PageNotFound = () => {
  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
        <div className="center" style={{ marginBottom: "10px" }}>
                    <img
                      src={
                        Product.ProductCode() === THEME.GA
                          ? LogoGaBig
                          : Product.ProductCode() === THEME.SA
                            ? SipLongLogo
                            : CricoLogo
                      }
                      style={{ height: "54px" }}
                      alt="Logo"
                    />
                  </div>
      <h1>404 Error</h1>
      <h2>Page Not Found</h2>
      <p>The page you are looking for does not exist.</p>
      <div className='flex' style={{justifyContent:"center", marginTop:"30px"}}>
      <div style={{width:"160px"}}> 
      <Link to="/"><ActionButton  label="Go to Home Page" type="button"/></Link>
      </div>
      </div>
    </div>
  );
};

export default PageNotFound;
